// import { Toast } from 'antd-mobile'
// todo toast 得最后再统一换
export let handleCatch = (e, message) => {
  console.error(e)
  window.toast.fail(message || e.message)
  // Toast.show({ icon: 'fail', content: message || e.message })
}
